module.exports = __webpack_public_path__ + "static/media/other.66b9f662.png";